import { jsx as _jsx } from "react/jsx-runtime";
import { HoverLimit } from "../../components/HoverLimit/HoverLimit";
export const QuantityInputMessage = ({ orderLimitEnabled, showHoverLimit, maxOrderLimit, productLimitCurrency, }) => {
    if (!orderLimitEnabled) {
        return null;
    }
    return (_jsx(HoverLimit, { displayStatus: showHoverLimit, productLimit: maxOrderLimit, productLimitCurrency: productLimitCurrency }));
};
//# sourceMappingURL=QuantityInputMessage.js.map